
import BTButton from "@common-components/bt-button/bt-button";
import { TasksGroup } from "@common-models/task-group";
import { getSelectedBoardId } from "@common-reducers/BoardsSelectors";
import { isTempId } from "@common-reducers/DBServiceThunks";
import {  createNewGroupAtBottom, createNewGroupAtTopThunk } from "@common-reducers/TaskThunks";
import { selectUser } from "@common-reducers/UserSelectors";
import { useAppDispatch } from "@common-reducers/hooks/store.hook";
import randomColor from 'randomcolor';
import { FaPlus } from "react-icons/fa";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import { AnalyticsService } from "@common-services/analytics-service";
import { namespace } from "@common-config/constants";
import { useTranslation } from "react-i18next";
type NewTaskGroupButtonProps = {
  position: "top" | "bottom";
}

export default function NewTaskGroupButton({position}: NewTaskGroupButtonProps) {
  const { t } = useTranslation(namespace);
  const dispatch = useAppDispatch()
  const user = useAppSelector(selectUser);
  const selectedBoardId = useAppSelector(getSelectedBoardId);
  const analyticsService: AnalyticsService = new AnalyticsService();

  function newTaskGroup() {
    if (user?._id && selectedBoardId) {
      const taskGroup: TasksGroup = {
        name: t('newTaskGroupButton.newGroup'),
        owner: user._id,
        createdBy: user._id,
        boardId: selectedBoardId,
        colorAccent: randomColor(),
      };

      if (position === "top"){
        taskGroup.order = 0
        dispatch(createNewGroupAtTopThunk(taskGroup));
     
      } else if (position === "bottom"){
        dispatch(createNewGroupAtBottom(taskGroup))
    
  
      }
      analyticsService.event("create_new_group", {
        category: "userEngagement",
        action: `create new group ${position}`,
      });
    }
  }

  return (
    <>
      <BTButton
      id="new-group-button"
      data-testid='tasks-header-new-group-button'
        sx={{  minWidth: "150px", flexShrink: '0', span: { margin: "0" } }}
        onClick={newTaskGroup}
        disabled={isTempId(selectedBoardId)}
      >
        <FaPlus style={{ marginInlineEnd: '5px', height: '14px', width: '14px' }} />
        {t('newTaskGroupButton.newGroup')}
      </BTButton>

    </>

  );
}
